import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  show(event) {
    event.preventDefault()
    if (window.FrontChat) window.FrontChat("show")
  }
}
